module.exports = __webpack_public_path__ + "static/media/checklist_active_new.ec588a5e.svg";